// src/components/Nav.jsx
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { login, logout } from "../auth";

export default function Nav({ showSearch, search, setSearch }) {
  const nav = useNavigate();
  const { user, allowed } = useAuth();

  const handleLogin = async () => {
    try { await login(); } catch (e) { console.error(e); }
  };

  const handleLogout = async () => {
    try { await logout(); } catch (e) { console.error(e); }
  };

  return (
    <header style={s.header}>
      <div style={s.inner} className="nav-inner">

        {/* Masthead */}
        <div style={s.masthead} onClick={() => nav("/")}>
          <div style={s.rule} className="nav-rule" />
          <div style={s.title} className="nav-title">MOTI'S KITCHEN LAB</div>
          <div style={s.sub}>PRIVATE RECIPE ARCHIVE</div>
          <div style={s.rule} className="nav-rule" />
        </div>

        {/* Right side */}
        <div style={s.right} className="nav-right">
          {showSearch && (
            <div style={s.searchWrap}>
              <SearchIcon />
              <input
                style={s.searchInput}
                className="nav-search"
                placeholder="חיפוש..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                dir="rtl"
              />
            </div>
          )}

          {allowed && (
            <button style={s.addBtn} className="btn-ink nav-add-btn" onClick={() => nav("/new")}>
              + מתכון חדש
            </button>
          )}

          {user ? (
            <div style={s.userWrap}>
              {user.photoURL && <img src={user.photoURL} alt="" style={s.avatar} />}
              <button style={s.logoutBtn} onClick={handleLogout}>יציאה</button>
            </div>
          ) : (
            <button style={s.loginBtn} className="btn-ink" onClick={handleLogin}>
              כניסה
            </button>
          )}
        </div>

      </div>
    </header>
  );
}

const SearchIcon = () => (
  <svg style={{ position:"absolute", right:10, width:15, height:15, color:"var(--warm)", pointerEvents:"none" }}
    viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/>
  </svg>
);

const s = {
  header:      { borderBottom:"1px solid var(--rule)", background:"var(--cream)", position:"sticky", top:0, zIndex:100 },
  inner:       { maxWidth:1180, margin:"0 auto", padding:"0 32px", height:88, display:"flex", alignItems:"center", justifyContent:"space-between" },
  masthead:    { textAlign:"center", cursor:"pointer", flexShrink:0 },
  rule:        { height:1, width:200, background:"var(--ink)", margin:"0 auto" },
  title:       { fontFamily:"var(--serif)", fontSize:26, fontWeight:700, letterSpacing:6, margin:"5px 0 2px", textTransform:"uppercase" },
  sub:         { fontSize:9, letterSpacing:4, color:"var(--warm)", textTransform:"uppercase", margin:"2px 0 5px" },
  right:       { display:"flex", alignItems:"center", gap:14 },
  searchWrap:  { position:"relative", display:"flex", alignItems:"center" },
  searchInput: { background:"transparent", border:"1px solid var(--rule)", padding:"7px 34px 7px 14px", fontSize:13, color:"var(--ink)", width:220 },
  addBtn:      { border:"1px solid var(--ink)", padding:"8px 20px", fontSize:12, letterSpacing:2, fontWeight:500, transition:"all .2s", textTransform:"uppercase" },
  userWrap:    { display:"flex", alignItems:"center", gap:8 },
  avatar:      { width:32, height:32, borderRadius:"50%", border:"1px solid var(--rule)" },
  logoutBtn:   { fontSize:11, letterSpacing:2, color:"var(--warm)", textTransform:"uppercase", cursor:"pointer", background:"none", border:"none" },
  loginBtn:    { border:"1px solid var(--ink)", padding:"8px 20px", fontSize:12, letterSpacing:2, fontWeight:500, transition:"all .2s", textTransform:"uppercase" },
};
